import React from 'react';
import styled from 'styled-components';

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
`;

const Button = styled.button`
  padding: 8px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
`;

const SecondaryButton = styled(Button)`
  background: #ebecf0;
  border: none;
  color: #172b4d;
  
  &:hover {
    background: #dfe1e6;
  }
`;

const PrimaryButton = styled(Button)`
  background: #0052cc;
  border: none;
  color: white;
  
  &:hover {
    background: #0065ff;
  }
`;

const DangerButton = styled(Button)`
  background: #ff5630;
  border: none;
  color: white;
  
  &:hover {
    background: #ff7452;
  }
`;

const ModalButtons = ({
  primaryText = 'Confirm',
  secondaryText = 'Cancel',
  onPrimaryClick,
  onSecondaryClick,
  isDanger = false,
  type = 'button'
}) => (
  <ButtonGroup>
    <SecondaryButton
      onClick={onSecondaryClick}
      type="button"
    >
      {secondaryText}
    </SecondaryButton>
    {isDanger ? (
      <DangerButton
        onClick={onPrimaryClick}
        type={type}
      >
        {primaryText}
      </DangerButton>
    ) : (
      <PrimaryButton
        onClick={onPrimaryClick}
        type={type}
      >
        {primaryText}
      </PrimaryButton>
    )}
  </ButtonGroup>
);

export default ModalButtons;